import axios from 'axios';
import { apiClientWithToken } from './client';

export type TaskSeverity = 'Pending' | 'Running' | 'Failed' | 'Succeeded' | string;

export interface TaskStateResponse {
  percentDone: number | null;
  severity: TaskSeverity;
  message: string;
  /**
   * ISO timestamp of the approximate end time, or null while unknown. When
   * present it lets the UI show an estimated remaining duration (end - now).
   */
  endTimeApprox: string | null;
  /** ISO start timestamp of the job. */
  startTime: string | null;
}

export interface TaskNotFound {
  notFound: true;
}

/**
 * Polls the V2 task state endpoint:
 * `GET /api/v2/{organizationId}/TaskStates/{jobId}`.
 *
 * A 404 means the task record was cleaned up, which the original UI treats
 * as successful completion.
 */
export const getTaskState = async (
  token: string,
  organizationId: string,
  jobId: string,
): Promise<TaskStateResponse | TaskNotFound> => {
  try {
    const response = await apiClientWithToken(token).get<TaskStateResponse>(
      `/api/v2/${organizationId}/TaskStates/${jobId}`,
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response?.status === 404) {
      return { notFound: true };
    }
    throw error;
  }
};
